// Packages
import { Component, createRef } from "react";
import userService from "../../../services/user.service";
import { withRouter } from "react-router-dom";
import { getFromLocalStorage } from "../../../utils/webStorage";
import { connect } from "react-redux";
import cuttingVideos from "../../../assets/images/cuttingVideos.png";
//css
import "bootstrap/dist/css/bootstrap.min.css";
import "../VideoLibrary.css";
import { FaPen, FaTrash } from "react-icons/fa";
import {
  openConfirmationPopup,
  openFailDialog,
  openRenamePopup,
  openSuccessPopup,
} from "../../../Redux/Actions/PopupActions";
import {
  openVideoEditPopup,
  setVideoEditPopupData,
} from "../../../Redux/Actions/VideoHighlightAction";
import {
  setInterCutVideoDataAfterDragAndDrop,
  setIntercutVideoData,
  setVideoPlayInformation,
} from "../../../Redux/Actions/IntercutVideoActions";
import { CircularProgress } from "@mui/material";
import DragAndDropContainer from "./DragAndDropContainer";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowBack";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import styles from "./InterCutVideo.module.css";
import VideoEditDialog from "../Video Highlights/VideoEditDialog";
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

class VideoMerge extends Component {
  constructor() {
    super();
    this.schoolId = getFromLocalStorage("schoolId");
    this.childRef = createRef();
    this.state = {
      selectedItem: null,
      selectedItemType: {
        otherAngle: false,
        endzoneRight: false,
        endZoneLeft: false,
        wideAngle: false,
        tightAngle: false,
      },
      isDragDisabled: false,
    };

    this.getPlaylistById = this.getPlaylistById.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  onDragEnd = (result, angleName, listName) => {
    const {
      intercutVideoData,
      setInterCutVideoInformationAfterDragAndDrop,
      setFailPopUpInformation,
    } = this.props;
    this.setState({ isDragDisabled: true });
    if (!result.destination) {
      this.setState({ isDragDisabled: false });
      return;
    }
    const endZonarVideoData = reorder(
      intercutVideoData?.interCutVideoList?.[angleName]?.[listName],
      result.source.index,
      result.destination.index
    );
    setInterCutVideoInformationAfterDragAndDrop({
      angleName: angleName,
      listName: listName,
      data: endZonarVideoData,
    });
    const intercutListOfIdAndPosition = endZonarVideoData.map(
      (item, index) => ({
        eventMediaId: item.id,
        positionNumber: index,
      })
    );
    userService
      .sendIntercutValues(intercutListOfIdAndPosition)
      .then(() => {
        this.setState({ isDragDisabled: false });
      })
      .catch((err) => {
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  singlePositionDrag = (item, status, angleName, listName) => {
    this.setState({ isDragDisabled: true });
    const {
      intercutVideoData,
      setInterCutVideoInformationAfterDragAndDrop,
      setFailPopUpInformation,
    } = this.props;
    const angleIndex = intercutVideoData?.interCutVideoList?.[angleName]?.[
      listName
    ].findIndex((data) => data.id == item.id);

    const destinationIndex = status
      ? angleIndex == 0
        ? intercutVideoData?.interCutVideoList?.[angleName]?.[listName].length -
          1
        : angleIndex - 1
      : angleIndex ===
        intercutVideoData?.interCutVideoList?.[angleName]?.[listName].length - 1
      ? 0
      : angleIndex + 1;

    const reorderedIntercutVideo = reorder(
      intercutVideoData?.interCutVideoList?.[angleName]?.[listName],
      angleIndex,
      destinationIndex
    );

    setInterCutVideoInformationAfterDragAndDrop({
      angleName: angleName,
      listName: listName,
      data: reorderedIntercutVideo,
    });

    const intercutListOfIdAndPosition = reorderedIntercutVideo.map(
      (item, index) => ({
        eventMediaId: item.id,
        positionNumber: index,
      })
    );

    userService
      .sendIntercutValues(intercutListOfIdAndPosition)
      .then(() => {
        this.setState({ isDragDisabled: false });
      })
      .catch(() => {
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  getPlaylistById = (
    schoolId,
    seasonName,
    seasonType,
    eventType,
    eventName,
    practiceName,
    opponentName,
    playlistId
  ) => {
    const { setIntercutVideoInformation } = this.props;
    setIntercutVideoInformation({
      schoolId,
      seasonName,
      seasonType,
      eventType,
      eventName,
      practiceName,
      opponentName,
      playlistId,
    });
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const seasonName = urlParams.get("season-year");
    const seasonType = urlParams.get("season-type");
    const eventType = urlParams.get("event-type");
    const opponentName = urlParams.get("week");
    const eventName = urlParams.get("event");
    const practiceName = urlParams.get("practice");
    const playlistId = urlParams.get("playlist-id");
    const { schoolId } = this;
    this.getPlaylistById(
      schoolId,
      seasonName,
      seasonType,
      eventType,
      eventName,
      practiceName,
      opponentName,
      playlistId
    );
  }

  shortText = (VideoName) => {
    let newStr;
    if (VideoName?.length > 18) {
      newStr = VideoName.substring(0, 18).concat("...");
    } else {
      newStr = VideoName;
    }
    return newStr;
  };

  handleItemSelection = (item, name) => {
    this.setState({
      selectedItem: item,
      selectedItemType: {
        [name]: true,
      },
    });
  };

  menuItemContent = (data, angleName, listName) => {
    const {
      setRenamePopupInformation,
      setConfirmationPopupInformation,
      setVideoEditPopup,
      videoEditPopupData,
      intercutVideoData,
    } = this.props;
    const arr = [
      {
        id: data.id,
        name: "Delete",
        icon: <FaTrash className="manage-section-iconss" />,
        ApiCall: (item) => {
          setConfirmationPopupInformation({
            confirmationPopup: {
              open: true,
              message: "Are You Sure, You Want To Delete This Video?",
              btnColor: "red",
              btnText: "Yes",
              type: "Delete Intercut Video",
              eventMediaId: item.id,
              angleName: angleName,
              listName: listName,
            },
          });
          this.childRef.current.handleClose();
        },
      },
      {
        id: data.id,
        name: "Rename",
        icon: <FaPen className="manage-section-iconss" />,
        ApiCall: (item) => {
          setRenamePopupInformation({
            renamePopup: {
              open: true,
              videoData: item,
              fieldToShow: "eventMediaCategory",
              type: "rename-video-from-intercut-video-page",
              angleName: angleName,
              listName: listName,
            },
          });
          this.childRef.current.handleClose();
        },
      },
      {
        id: data.id,
        name: "Edit",
        icon: (
          <img
            src={cuttingVideos}
            style={{ width: "25px", marginRight: "10px" }}
          />
        ),
        ApiCall: (item) => {
          setVideoEditPopup(true);
          videoEditPopupData({
            loading: false,
            videoData: item,
            fieldToReplace: "eventMediaCategory",
            angleName: angleName,
            listName: listName,
          });
          this.childRef.current.handleClose();
        },
      },
    ];
    return arr;
  };

  render() {
    const { selectedItem, selectedItemType, isDragDisabled } = this.state;
    const { intercutVideoData, history } = this.props;
    return (
      <div className={styles.container}>
        <SchoolAdminDashboard />
        <VideoEditDialog />
        {intercutVideoData?.loading ? (
          <div className="full-page-loading">
            <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
              <CircularProgress
                className="rounded-circle"
                color="success"
                sx={{ fontSize: 10, color: "#002244" }}
                disableShrink
              />
            </div>
          </div>
        ) : (
          <div className="mg-top-80">
            <div
              className={`grey-border d-flex align-items-center justify-between ${styles.header}`}
            >
              <span className="fs-20 semi-bold dblack">
                {intercutVideoData?.angleCount} Angles,{" "}
                {intercutVideoData?.totalVideoCount} Videos
              </span>
              <button className="saveBtn1" onClick={() => history.goBack()}>
                <ArrowCircleLeftIcon className="mx-1 addIconSc" />
                Back To Library
              </button>
            </div>
            <div className="grid-container pd-20">
              {intercutVideoData?.interCutVideoList?.endZonarData
                ?.endZonarDataList.length > 0 && (
                <DragAndDropContainer
                  label="End Zone Right"
                  intercutVideoData={intercutVideoData}
                  itemSelectionName="endZoneLeft"
                  selectedItemType={selectedItemType.endZoneLeft}
                  isDragDisabled={isDragDisabled}
                  handleOnDrag={this.onDragEnd}
                  selectedItem={selectedItem}
                  handleItemSelection={this.handleItemSelection}
                  menuItemContent={this.menuItemContent}
                  shortText={this.shortText}
                  angleName="endZonarData"
                  listName="endZonarDataList"
                  singlePositionDrag={this.singlePositionDrag}
                  ref={this.childRef}
                />
              )}

              {intercutVideoData?.interCutVideoList?.otherAngleData
                ?.otherAngleDataList.length > 0 && (
                <DragAndDropContainer
                  label="Other"
                  itemSelectionName="otherAngle"
                  intercutVideoData={intercutVideoData}
                  selectedItemType={selectedItemType.otherAngle}
                  isDragDisabled={isDragDisabled}
                  handleOnDrag={this.onDragEnd}
                  selectedItem={selectedItem}
                  handleItemSelection={this.handleItemSelection}
                  menuItemContent={this.menuItemContent}
                  shortText={this.shortText}
                  angleName="otherAngleData"
                  listName="otherAngleDataList"
                  singlePositionDrag={this.singlePositionDrag}
                  ref={this.childRef}
                />
              )}

              {intercutVideoData?.interCutVideoList?.wideAngleData
                ?.wideAngleDataList.length > 0 && (
                <DragAndDropContainer
                  label="Wide Angle"
                  itemSelectionName="wideAngle"
                  intercutVideoData={intercutVideoData}
                  selectedItemType={selectedItemType.wideAngle}
                  isDragDisabled={isDragDisabled}
                  handleOnDrag={this.onDragEnd}
                  selectedItem={selectedItem}
                  handleItemSelection={this.handleItemSelection}
                  menuItemContent={this.menuItemContent}
                  shortText={this.shortText}
                  angleName="wideAngleData"
                  listName="wideAngleDataList"
                  singlePositionDrag={this.singlePositionDrag}
                  ref={this.childRef}
                />
              )}

              {intercutVideoData?.interCutVideoList?.tightAngleData
                ?.tightAngleDataList.length > 0 && (
                <DragAndDropContainer
                  label="Tight Angle"
                  itemSelectionName="tightAngle"
                  intercutVideoData={intercutVideoData}
                  selectedItemType={selectedItemType.tightAngle}
                  isDragDisabled={isDragDisabled}
                  handleOnDrag={this.onDragEnd}
                  selectedItem={selectedItem}
                  handleItemSelection={this.handleItemSelection}
                  menuItemContent={this.menuItemContent}
                  shortText={this.shortText}
                  angleName="tightAngleData"
                  listName="tightAngleDataList"
                  singlePositionDrag={this.singlePositionDrag}
                  ref={this.childRef}
                />
              )}

              {intercutVideoData?.interCutVideoList?.endZonalData
                ?.endZonalDataList.length > 0 && (
                <DragAndDropContainer
                  label="End Zone Left"
                  itemSelectionName="endzoneRight"
                  intercutVideoData={intercutVideoData}
                  selectedItemType={selectedItemType.endzoneRight}
                  isDragDisabled={isDragDisabled}
                  handleOnDrag={this.onDragEnd}
                  selectedItem={selectedItem}
                  handleItemSelection={this.handleItemSelection}
                  menuItemContent={this.menuItemContent}
                  shortText={this.shortText}
                  angleName="endZonalData"
                  listName="endZonalDataList"
                  singlePositionDrag={this.singlePositionDrag}
                  ref={this.childRef}
                />
              )}
            </div>

            <div className="clear30"></div>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setConfirmationPopupInformation: (obj) =>
      openConfirmationPopup(dispatch, obj),
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    setFailPopUpInformation: (obj) => openFailDialog(dispatch, obj),
    setIntercutVideoInformation: (obj) => setIntercutVideoData(dispatch, obj),
    setInterCutVideoInformationAfterDragAndDrop: (obj) =>
      setInterCutVideoDataAfterDragAndDrop(dispatch, obj),
    setRenamePopupInformation: (obj) => openRenamePopup(dispatch, obj),
    setVideoPlayInformation: (obj) => setVideoPlayInformation(dispatch, obj),
    setVideoEditPopup: (obj) => openVideoEditPopup(dispatch, obj),
    videoEditPopupData: (obj) => setVideoEditPopupData(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return {
    intercutVideoData: state.IntercutVideoData,
    videoHighlightData: state.videoHighlightData,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VideoMerge)
);
